/* Source-faithful Mom and Grandma titles with measured openings; Cookie name font. */
(function(root,factory){if(typeof module==='object'&&module.exports)module.exports=factory();else root.FamilyCatalog=factory();})(typeof globalThis!=='undefined'?globalThis:this,function(){
'use strict';
const data={
  "TEMPLATES": {
    "mom": {
      "id": "mom",
      "label": "Mom",
      "option": "M1",
      "family": "mom",
      "file": "je-family-mom.png",
      "imageWidth": 1445,
      "imageHeight": 523,
      "geometry": {
        "xMin": 0,
        "yMin": 0,
        "xMax": 1,
        "yMax": 1
      },
      "opening": {
        "x": 0,
        "y": 177,
        "width": 1445,
        "height": 168
      },
      "divider": {
        "top": 345,
        "bottom": 361
      }
    },
    "mama": {
      "id": "mama",
      "label": "Mama",
      "option": "M2",
      "family": "mom",
      "file": "je-family-mama.png",
      "imageWidth": 1426,
      "imageHeight": 391,
      "geometry": {
        "xMin": 0,
        "yMin": 0,
        "xMax": 1,
        "yMax": 1
      },
      "opening": {
        "x": 0,
        "y": 131,
        "width": 1426,
        "height": 129
      },
      "divider": {
        "top": 260,
        "bottom": 272
      }
    },
    "mommy": {
      "id": "mommy",
      "label": "Mommy",
      "option": "M3",
      "family": "mom",
      "file": "je-family-mommy.png",
      "imageWidth": 1488,
      "imageHeight": 408,
      "geometry": {
        "xMin": 0,
        "yMin": 0,
        "xMax": 1,
        "yMax": 1
      },
      "opening": {
        "x": 0,
        "y": 145,
        "width": 1488,
        "height": 154
      },
      "divider": {
        "top": 299,
        "bottom": 315
      }
    },
    "momma": {
      "id": "momma",
      "label": "Momma",
      "option": "M4",
      "family": "mom",
      "file": "je-family-momma.png",
      "imageWidth": 1487,
      "imageHeight": 414,
      "geometry": {
        "xMin": 0,
        "yMin": 0,
        "xMax": 1,
        "yMax": 1
      },
      "opening": {
        "x": 0,
        "y": 147,
        "width": 1487,
        "height": 161
      },
      "divider": {
        "top": 308,
        "bottom": 323
      }
    },
    "mother": {
      "id": "mother",
      "label": "Mother",
      "option": "M5",
      "family": "mom",
      "file": "je-family-mother.png",
      "imageWidth": 881,
      "imageHeight": 202,
      "geometry": {
        "xMin": 0,
        "yMin": 0,
        "xMax": 1,
        "yMax": 1
      },
      "opening": {
        "x": 0,
        "y": 71,
        "width": 881,
        "height": 80
      },
      "divider": {
        "top": 151,
        "bottom": 160
      }
    },
    "grandma": {
      "id": "grandma",
      "label": "Grandma",
      "option": "G1",
      "family": "grandma",
      "file": "je-family-grandma.png",
      "imageWidth": 1414,
      "imageHeight": 299,
      "geometry": {
        "xMin": 0,
        "yMin": 0,
        "xMax": 1,
        "yMax": 1
      },
      "opening": {
        "x": 0,
        "y": 100,
        "width": 1414,
        "height": 119
      },
      "divider": {
        "top": 219,
        "bottom": 240
      }
    },
    "granny": {
      "id": "granny",
      "label": "Granny",
      "option": "G2",
      "family": "grandma",
      "file": "je-family-granny.png",
      "imageWidth": 1406,
      "imageHeight": 349,
      "geometry": {
        "xMin": 0,
        "yMin": 0,
        "xMax": 1,
        "yMax": 1
      },
      "opening": {
        "x": 0,
        "y": 118,
        "width": 1406,
        "height": 129
      },
      "divider": {
        "top": 247,
        "bottom": 269
      }
    },
    "grammy": {
      "id": "grammy",
      "label": "Grammy",
      "option": "G3",
      "family": "grandma",
      "file": "je-family-grammy.png",
      "imageWidth": 1455,
      "imageHeight": 358,
      "geometry": {
        "xMin": 0,
        "yMin": 0,
        "xMax": 1,
        "yMax": 1
      },
      "opening": {
        "x": 0,
        "y": 135,
        "width": 1455,
        "height": 118
      },
      "divider": {
        "top": 253,
        "bottom": 279
      }
    },
    "nana": {
      "id": "nana",
      "label": "Nana",
      "option": "G4",
      "family": "grandma",
      "file": "je-family-nana.png",
      "imageWidth": 1475,
      "imageHeight": 531,
      "geometry": {
        "xMin": 0,
        "yMin": 0,
        "xMax": 1,
        "yMax": 1
      },
      "opening": {
        "x": 0,
        "y": 183,
        "width": 1475,
        "height": 205
      },
      "divider": {
        "top": 388,
        "bottom": 411
      }
    },
    "grandmother": {
      "id": "grandmother",
      "label": "Grandmother",
      "option": "G5",
      "family": "grandma",
      "file": "je-family-grandmother.png",
      "imageWidth": 1443,
      "imageHeight": 197,
      "geometry": {
        "xMin": 0,
        "yMin": 0,
        "xMax": 1,
        "yMax": 1
      },
      "opening": {
        "x": 0,
        "y": 73,
        "width": 1443,
        "height": 71
      },
      "divider": {
        "top": 144,
        "bottom": 157
      }
    },
    "meemaw": {
      "id": "meemaw",
      "label": "Meemaw",
      "option": "G6",
      "family": "grandma",
      "file": "je-family-meemaw.png",
      "imageWidth": 1500,
      "imageHeight": 368,
      "geometry": {
        "xMin": 0,
        "yMin": 0,
        "xMax": 1,
        "yMax": 1
      },
      "opening": {
        "x": 0,
        "y": 122,
        "width": 1500,
        "height": 134
      },
      "divider": {
        "top": 256,
        "bottom": 272
      }
    },
    "mimi": {
      "id": "mimi",
      "label": "Mimi",
      "option": "G7",
      "family": "grandma",
      "file": "je-family-mimi.png",
      "imageWidth": 1420,
      "imageHeight": 638,
      "geometry": {
        "xMin": 0,
        "yMin": 0,
        "xMax": 1,
        "yMax": 1
      },
      "opening": {
        "x": 0,
        "y": 146,
        "width": 1420,
        "height": 285
      },
      "divider": {
        "top": 431,
        "bottom": 452
      }
    },
    "abuela": {
      "id": "abuela",
      "label": "Abuela",
      "option": "G8",
      "family": "grandma",
      "file": "je-family-abuela.png",
      "imageWidth": 1456,
      "imageHeight": 360,
      "geometry": {
        "xMin": 0,
        "yMin": 0,
        "xMax": 1,
        "yMax": 1
      },
      "opening": {
        "x": 0,
        "y": 122,
        "width": 1456,
        "height": 130
      },
      "divider": {
        "top": 252,
        "bottom": 271
      }
    },
    "yaya": {
      "id": "yaya",
      "label": "Yaya",
      "option": "G9",
      "family": "grandma",
      "file": "je-family-yaya.png",
      "imageWidth": 1469,
      "imageHeight": 631,
      "geometry": {
        "xMin": 0,
        "yMin": 0,
        "xMax": 1,
        "yMax": 1
      },
      "opening": {
        "x": 0,
        "y": 220,
        "width": 1469,
        "height": 252
      },
      "divider": {
        "top": 472,
        "bottom": 493
      }
    }
  },
  "FONT": {
    "id": "cookie",
    "family": "Cookie",
    "cssFamily": "JE Family Cookie",
    "weight": 400,
    "coverage": [
      32,
      33,
      34,
      35,
      36,
      37,
      38,
      39,
      40,
      41,
      42,
      43,
      44,
      45,
      46,
      47,
      48,
      49,
      50,
      51,
      52,
      53,
      54,
      55,
      56,
      57,
      58,
      59,
      60,
      61,
      62,
      63,
      64,
      65,
      66,
      67,
      68,
      69,
      70,
      71,
      72,
      73,
      74,
      75,
      76,
      77,
      78,
      79,
      80,
      81,
      82,
      83,
      84,
      85,
      86,
      87,
      88,
      89,
      90,
      91,
      92,
      93,
      94,
      95,
      96,
      97,
      98,
      99,
      100,
      101,
      102,
      103,
      104,
      105,
      106,
      107,
      108,
      109,
      110,
      111,
      112,
      113,
      114,
      115,
      116,
      117,
      118,
      119,
      120,
      121,
      122,
      123,
      124,
      125,
      126,
      161,
      162,
      163,
      164,
      165,
      166,
      167,
      168,
      169,
      170,
      171,
      172,
      174,
      175,
      176,
      177,
      178,
      179,
      180,
      181,
      182,
      183,
      185,
      186,
      187,
      188,
      189,
      190,
      191,
      192,
      193,
      194,
      195,
      196,
      197,
      198,
      199,
      200,
      201,
      202,
      203,
      204,
      205,
      206,
      207,
      208,
      209,
      210,
      211,
      212,
      213,
      214,
      215,
      216,
      217,
      218,
      219,
      220,
      221,
      222,
      223,
      224,
      225,
      226,
      227,
      228,
      229,
      230,
      231,
      232,
      233,
      234,
      235,
      236,
      237,
      238,
      239,
      240,
      241,
      242,
      243,
      244,
      245,
      246,
      247,
      248,
      249,
      250,
      251,
      252,
      253,
      254,
      255,
      305,
      338,
      339,
      710,
      730,
      732,
      8211,
      8212,
      8216,
      8217,
      8218,
      8220,
      8221,
      8222,
      8226,
      8230,
      8249,
      8250,
      8260,
      8364,
      8482,
      8722
    ],
    "label": "Cookie",
    "file": "je-nurse-cookie.woff2",
    "unitsPerEm": 1000
  },
  "LISTINGS": {
    "1891280584": {
      "family": "mom",
      "brand": "stanley",
      "defaultHeight": 120
    },
    "1906205045": {
      "family": "mom",
      "brand": "owala",
      "defaultHeight": 140
    },
    "1906207913": {
      "family": "mom",
      "brand": "owala",
      "defaultHeight": 140
    },
    "4466884922": {
      "family": "mom",
      "brand": "owala",
      "defaultHeight": 140
    },
    "4493524409": {
      "family": "mom",
      "brand": "owala",
      "defaultHeight": 140
    },
    "4364329327": {
      "family": "grandma",
      "brand": "owala",
      "defaultHeight": 160
    }
  },
  "FAMILY_DEFAULTS": {
    "mom": {
      "owala": 140,
      "stanley": 120
    },
    "grandma": {
      "owala": 160
    }
  }
};
function freeze(value){if(value&&typeof value==='object'){Object.values(value).forEach(freeze);Object.freeze(value);}return value;}
return freeze(data);
});
